/* eslint-disable import/no-default-export */
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { HeaderTestIds } from '@trello/webdriverio-tests';
// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import { CreateMenuPopoverId } from 'components/popovers/popover-ids';
// eslint-disable-next-line no-restricted-imports
import { showPopover, State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { isPopoverShown } from 'selectors/popovers';

// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
import HeaderButton from './button';

const HeaderCreateMenuPopoverPromise = import(/* webpackChunkName: "gamma-create-menu-popover" */ 'components/popovers/header-create-menu');
const HeaderCreateMenuPopover = lazy(() => HeaderCreateMenuPopoverPromise);

interface StateProps {
  isActive: boolean;
}

interface DispatchProps {
  onClick: React.MouseEventHandler;
}

type AllProps = StateProps & DispatchProps;

class CreateMenuButton extends React.Component<AllProps> {
  createMenuButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const { isActive, onClick } = this.props;

    return (
      <>
        <HeaderButton
          icon={IconName.Add}
          onClick={onClick}
          ref={this.createMenuButtonRef}
          testId={HeaderTestIds.CreateMenuButton}
        />
        {isActive && (
          <Suspense fallback={null}>
            <HeaderCreateMenuPopover
              target={() => this.createMenuButtonRef.current}
            />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State): StateProps => {
  return {
    isActive: isPopoverShown(state, CreateMenuPopoverId),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>): DispatchProps => {
  return {
    onClick() {
      Analytics.trackUE({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.ADD_MENU,
        method: 'by clicking header add menu button',
      });

      dispatch(showPopover({ name: CreateMenuPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateMenuButton);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/create-menu-button.tsx